import React, { useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import WebSidebar from './WebSidebar';
import CalculatorModal from '../Modals/CalculatorModal';
import { WebShellProvider, useWebShell } from './WebShellContext';
import { useLayoutSize } from '../../theme';

type Props = {
  children: React.ReactNode;
  isDemoMode?: boolean;
  cartBadgeOverride?: number;
};

export default function WebSidebarLayout({
  children,
  isDemoMode = false,
  cartBadgeOverride,
}: Props) {
  const { useSidebarNav } = useLayoutSize();

  const styles = useMemo(() => createStyles(), []);
  const [calculatorOpen, setCalculatorOpen] = useState(false);

  if (!useSidebarNav) return <>{children}</>;

  return (
    <WebShellProvider>
      <WebSidebarLayoutInner
        calculatorOpen={calculatorOpen}
        setCalculatorOpen={setCalculatorOpen}
        styles={styles}
        isDemoMode={isDemoMode}
        cartBadgeOverride={cartBadgeOverride}>
        {children}
      </WebSidebarLayoutInner>
    </WebShellProvider>
  );
}

function WebSidebarLayoutInner({
  children,
  calculatorOpen,
  setCalculatorOpen,
  styles,
  isDemoMode,
  cartBadgeOverride,
}: {
  children: React.ReactNode;
  calculatorOpen: boolean;
  setCalculatorOpen: (v: boolean) => void;
  styles: any;
  isDemoMode: boolean;
  cartBadgeOverride?: number;
}) {
  const { header } = useWebShell();

  return (
    <View style={styles.root}>
      {header ? <View style={styles.header}>{header}</View> : null}
      <View style={styles.container}>
        <WebSidebar
          isDemoMode={isDemoMode}
          cartBadgeOverride={cartBadgeOverride}
          onOpenCalculator={() => setCalculatorOpen(true)}
        />
        <View style={styles.content}>{children}</View>
      </View>
      <CalculatorModal
        visible={calculatorOpen}
        onDismiss={() => setCalculatorOpen(false)}
        storageKey="calculator:web:sidebar"
      />
    </View>
  );
}

const createStyles = () =>
  StyleSheet.create({
    root: {
      flex: 1,
    },
    header: {
      width: '100%',
      flexShrink: 0,
    },
    container: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'stretch',
    },
    content: {
      flex: 1,
      minWidth: 0,
    } as any,
  });
